import { EmptyInstance } from "core/features/components/mixins/empty-instance";
import { EventEmitterMixin } from "front-end/mixins/event-emitter.mixin";
import { IFilterParameterComponent } from "./filter-parameter.component";
import { FilterParameterModel } from "./models/filter-parameter.model";

export class FilterDropdownParameterComponent extends EventEmitterMixin(EmptyInstance) implements IFilterParameterComponent {
    public static SELECTOR: string = ".js-ina-filter-dropdown-parameter";

    private _currentContext: JQuery = $();

    private _classMap = {
        js: {
            title: `${FilterDropdownParameterComponent.SELECTOR}__title`,
            option: `${FilterDropdownParameterComponent.SELECTOR}__option`,
            value: `${FilterDropdownParameterComponent.SELECTOR}__value`
        }
    };

    private _title: JQuery;
    private _options: JQuery;
    private _value: JQuery;

    public getName(): string {
        return this._value.attr("name");
    }

    public setTitle(title: string): FilterDropdownParameterComponent {
        this._title.text(title);
        return this;
    }

    public reset(value?: string): FilterDropdownParameterComponent {
        if(!value) {
            const title = this._currentContext.data().placeholder as string;
            this.setValue("").setTitle(title);
        } else {
            this.setValue(value).setTitle(value);
        }
        return this;
    }

    public getValue(): string {
        return this._value.val() as string;
    }

    public getParam(): FilterParameterModel {
        return {
            name: this.getName(),
            sortOrder: this.sortOrder(),
            value: {
                name: this.stringifyValue(this.getValue()),
                data: this.getValue(),
                sortOrder: -1
            }
        };
    }

    public setValue(value: string): FilterDropdownParameterComponent {
        this._value.val(value);
        this.emit("changed", this.getParam());

        return this;
    }

    public isEmpty(): boolean {
        return !this.getValue();
    }

    public stringifyValue(value: string): string {
        let str = "";
        this._options.each((index, entry) => {
            const option = $(entry);
            const data = option.data();
            if (`${data.value as string}` === value) {
                str = data.displayName as string;
            }
        });

        return str;
    }

    public sortOrder(): number {
        return this._currentContext.data().sortOrder as number;
    }

    public setInitialValue(): void {
        const initialValue = this._value.val() as string;
        if (initialValue !== undefined && initialValue !== "") {
            this.setValue(initialValue).setTitle(initialValue);
        }
    }

    private handleOptionClick($option: JQuery): void {
        const value = $option.data().value as string;
        this.setValue(value).setTitle(value);
    }

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    public removeValue(value: string): void {
        this.reset();
    }

    private bindEvents(): void {
        this._options.on("click", (e) => {
            const $option = $(e.target);
            this.handleOptionClick($option);
        });
    }

    private parseContext(): void {
        this._title = $(this._classMap.js.title, this._currentContext);
        this._options = $(this._classMap.js.option, this._currentContext);
        this._value = $(this._classMap.js.value, this._currentContext);
    }

    public init(context: JQuery): void {
        this._currentContext = context || this._currentContext;

        this.parseContext();
        this.bindEvents();
        // this.setInitialValue();
    }
}
